import {
  createContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';

export interface TabLinePosition {
  left: number;
  width: number;
}

export const NavContext = createContext<
  [TabLinePosition | null, Dispatch<SetStateAction<TabLinePosition | null>>]
>([null, () => {}]);

export const NavContextProvider = ({ children }: { children: ReactNode }) => {
  const state = useState<TabLinePosition | null>(null);

  return <NavContext.Provider value={state}>{children}</NavContext.Provider>;
};
